import React from 'react';
import makeTypedTranslation from '@hooks/typedTranslations/makeTypedTranslation';
import KPeopleLogo from '@assets/svgs/people.svg';
import styles from './SignUpHeader.module.scss';

const SignUpHeader = () => {
  const { useTypedTranslation } = makeTypedTranslation('common');

  const { t: translate } = useTypedTranslation('common');

  return (
    <div className={styles.signUpHeaderWrap}>
      <KPeopleLogo data-testid="header-logo" className={styles.signUpHeaderLogo} />
      <h4 className="h4 no-margin">{translate('authLayout.sign_up_title')}</h4>
      <p className="main-body-text title-dark no-margin">{translate('authLayout.sign_up_subtitle')}</p>
    </div>
  );
};

export default SignUpHeader;
